/* LA Flight School :: Course Selector ("Flight Plan Tabs") :: behaviour for sections/lafs-course-selector.liquid
   - Tabs (click, arrow keys, Home/End, swipe on touch screens).
   - Private Pilot: package switch updates price, struck price, hours, financing and the Enroll/Claim button (data-pp-tier).
   - Discovery: flight / length / passenger update the price and the Book and Gift buttons (data-k, data-m, data-pax),
     which snippets/sx-book (assets/sx-book.js) turns into the weight check + live calendar. Prices: window.SXD (snippets/sx-data).
   - Offer: live time left; at the deadline the offer parts hide and the buttons switch to Enroll Now without a reload.
   Prices in the config are cents, straight from the products. Safe to load more than once.
   v98 (Black Friday): a package may carry its own "save" (from the Price Hub); it wins over the block's flat "save". */
(function () {
  'use strict';
  if (window.__lcsInit) { window.__lcsInit(); return; }

  function money(c) { return '$' + Math.round(c / 100).toLocaleString('en-US'); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function init(root) {
    if (!root || root.__lcs) return;
    var cfgEl = root.querySelector('script[data-lcs-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    root.__lcs = true;
    var endMs = (cfg.endsS || 0) * 1000;
    function isLive() { return Date.now() < endMs; }
    var live = isLive();
    function $(s, el) { return (el || root).querySelector(s); }
    function $$(s, el) { return [].slice.call((el || root).querySelectorAll(s)); }
    function setText(el, txt, tick) {
      if (!el || el.textContent === txt) return;
      el.textContent = txt;
      if (tick) { el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); }
    }

    /* ---------- tabs ---------- */
    var tablist = $('[role="tablist"]'), tabs = $$('[role="tab"]'), panels = $$('[role="tabpanel"]');
    var order = tabs.map(function (t) { return t.getAttribute('data-tab'); });
    var cur = order[0];
    function selectTab(key, focus) {
      cur = key;
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tab') === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
        if (on && tablist.scrollWidth > tablist.clientWidth && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== key; });
      tablist.style.setProperty('--i', order.indexOf(key));
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { selectTab(t.getAttribute('data-tab')); }); });
    tablist.addEventListener('keydown', function (e) {
      var i = order.indexOf(cur), n = order.length, j = null;
      if (e.key === 'ArrowRight') j = (i + 1) % n;
      else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      if (j === null) return;
      e.preventDefault(); selectTab(order[j], true);
    });
    var wrap = $('.lcs-panels'), sx = null, sy = 0;
    wrap.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; sx = null;
      if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      if (e.target.closest && e.target.closest('.lcs-chips,.lcs-seg,.lcs-len')) return;
      var i = order.indexOf(cur) + (dx < 0 ? 1 : -1);
      if (i >= 0 && i < order.length) selectTab(order[i]);
    }, { passive: true });
    /* the theme editor selects a block -> show its tab */
    root.addEventListener('shopify:block:select', function (e) { var id = e.detail && e.detail.blockId; if (id && order.indexOf(id) > -1) selectTab(id); });

    /* ---------- panels ---------- */
    var updaters = [];
    panels.forEach(function (panel) {
      var id = panel.getAttribute('data-panel'), kind = panel.getAttribute('data-kind'), b = (cfg.blocks || {})[id] || {};
      if (kind === 'ppl' && b.tiers) updaters.push(ppl(panel, b));
      else if (kind === 'airline') updaters.push(airline(panel, b));
      else if (kind === 'discovery') updaters.push(discovery(panel, b));
    });

    function ppl(panel, b) {
      var st = 0;
      function save(t) { return typeof t.save === 'number' ? t.save : b.save; }
      function price(t) { return live ? t.was - save(t) : t.was; }
      function render() {
        var t = b.tiers[st];
        $$('[data-tier]', panel).forEach(function (btn) { btn.setAttribute('aria-pressed', +btn.getAttribute('data-tier') === st ? 'true' : 'false'); });
        setText($('[data-ppl-now]', panel), money(price(t)), true);
        setText($('[data-ppl-was]', panel), money(t.was));
        setText($('.lcs-amt .lcs-save', panel), 'Save ' + money(save(t)));
        setText($('[data-ppl-fin]', panel), money(b.down) + ' down + ' + t.n + ' × ' + money(Math.round((price(t) - b.down) / t.n / 100) * 100) + '/mo');
        ['ac', 'sim', 'dual', 'ground'].forEach(function (h) { setText($('[data-h="' + h + '"]', panel), String(t[h]), true); });
        var a = $('[data-ppl-cta]', panel);
        if (a) {
          a.setAttribute('data-pp-tier', t.tier);
          setText($('[data-cta-t]', a), live ? 'Claim ' + money(save(t)) + ' Off' : 'Enroll Now');
          setText($('[data-cta-s]', a), t.name + ' Package · ' + money(price(t)));
        }
        var from = root.querySelector('[data-from="ppl"]');
        if (from) setText(from, money(price(b.tiers[0])));
      }
      $$('[data-tier]', panel).forEach(function (btn) { btn.addEventListener('click', function () { st = +btn.getAttribute('data-tier'); render(); }); });
      render();
      return render;
    }

    function airline(panel, b) {
      function render() {
        if (!b.was) return;
        var now = live ? b.was - b.save : b.was;
        $$('.lcs-now', panel).forEach(function (el) { setText(el, money(now)); });
        setText($('[data-air-now]', panel), money(now));
        var t = $('[data-cta-t]', panel); if (t) setText(t, live ? 'Claim ' + money(b.save) + ' Off' : 'Enroll Now');
        var from = root.querySelector('[data-from="airline"]'); if (from) setText(from, money(now));
      }
      render();
      return render;
    }

    function discovery(panel, b) {
      var st = { k: 'one', m: 60, pax: 0 };
      var IMGS = {};
      try { IMGS = JSON.parse(($('script[data-disc-imgs]', panel) || {}).textContent || '{}'); } catch (e) {}
      var NAMES = { one: 'For One', two: 'For Two', sporty: 'Sporty DA20', lux: 'Luxury Cirrus', multi: 'Multi-Engine' };
      var AC = { one: 'Diamond DA20, Cessna 162 Or Piper Warrior', two: 'Piper Warrior', sporty: 'Diamond DA20-C1', lux: 'Cirrus SR22 Turbo', multi: 'Piper Seminole' };
      var SEATS = { one: '1 flyer', two: '2 people', sporty: '1 flyer', lux: '1 flyer', multi: '2 people' };
      function sxd() { return window.SXD && window.SXD.prices ? window.SXD.prices : null; }
      function p(k, m, pax) { /* dollars */
        var P = sxd();
        if (P && P[k] && P[k][m]) {
          if (pax && k === 'lux' && P.luxpax && P.luxpax[m]) return P.luxpax[m];
          return P[k][m];
        }
        return m === 60 && !pax && b.p60 && b.p60[k] ? b.p60[k] / 100 : null;
      }
      function d(n) { return '$' + Number(n).toLocaleString('en-US'); }
      var lens = $$('[data-len]', panel), paxBtn = $('[data-paxbtn]', panel);
      function render() {
        var hasLen = !!sxd();
        lens.forEach(function (x) { x.disabled = !hasLen && +x.getAttribute('data-len') !== 60; });
        if (!hasLen) st.m = 60;
        var canPax = st.k === 'lux' && !!p('lux', st.m, 1);
        if (!canPax) st.pax = 0;
        var price = p(st.k, st.m, st.pax);
        $$('[data-fk]', panel).forEach(function (btn) {
          var k = btn.getAttribute('data-fk'), on = k === st.k, v = p(k, st.m, on ? st.pax : 0);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (v) setText($('[data-cp="' + k + '"]', btn), d(v));
        });
        lens.forEach(function (x) { x.setAttribute('aria-pressed', +x.getAttribute('data-len') === st.m ? 'true' : 'false'); });
        paxBtn.disabled = st.k !== 'lux';
        paxBtn.setAttribute('aria-pressed', st.pax ? 'true' : 'false');
        var extra = canPax ? p('lux', st.m, 1) - p('lux', st.m, 0) : 0;
        setText($('[data-paxnote]', panel), st.k === 'lux' && extra ? '+' + d(extra) + ' · Cirrus' : 'Cirrus Only');
        if (price) setText($('[data-d-now]', panel), d(price), true);
        setText($('[data-d-name]', panel), NAMES[st.k]);
        setText($('[data-d-len]', panel), st.m + ' Min' + (st.pax ? ' · +1 Passenger' : ''));
        setText($('[data-d-ac]', panel), AC[st.k] + ' · ' + (st.pax ? '1 flyer + 1 passenger' : SEATS[st.k]));
        var book = $('[data-d-book]', panel);
        book.setAttribute('data-k', st.k); book.setAttribute('data-m', st.m); book.setAttribute('data-pax', st.pax ? '1' : '0');
        if (price) setText($('[data-d-book-t]', panel), 'Book · ' + d(price));
        var gift = $('[data-d-gift]', panel);
        if (gift) {
          gift.hidden = st.k === 'sporty';
          gift.setAttribute('data-k', st.k); gift.setAttribute('data-m', st.m);
          gift.parentNode.classList.toggle('is-solo', gift.hidden);
        }
        var img = $('[data-disc-img]', panel), im = IMGS[st.k];
        if (img && im && im.src && img.getAttribute('data-k') !== st.k) {
          img.setAttribute('data-k', st.k);
          img.removeAttribute('srcset'); img.src = im.src; img.alt = im.alt || '';
        }
      }
      $$('[data-fk]', panel).forEach(function (btn) { btn.addEventListener('click', function () { st.k = btn.getAttribute('data-fk'); render(); }); });
      lens.forEach(function (x) { x.addEventListener('click', function () { if (x.disabled) return; st.m = +x.getAttribute('data-len'); render(); }); });
      paxBtn.addEventListener('click', function () { st.pax = st.pax ? 0 : 1; render(); });
      render();
      /* SXD may arrive after this script (defer order): repaint once it is there */
      if (!sxd()) { var tries = 0, iv = setInterval(function () { if (sxd() || ++tries > 20) { clearInterval(iv); render(); } }, 250); }
      return render;
    }

    /* ---------- offer clock ---------- */
    function promo() {
      $$('[data-lcs-promo]').forEach(function (el) { el.hidden = !live; });
      $$('[data-lcs-ever]').forEach(function (el) { el.hidden = live; });
    }
    function tick() {
      var now = isLive();
      if (now !== live) { live = now; promo(); updaters.forEach(function (u) { u(); }); }
      if (!live) return;
      var ms = Math.max(0, endMs - Date.now()), dd = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60;
      var txt = dd > 0 ? dd + 'd ' + pad(h) + 'h ' + pad(m) + 'm' : 'Last Day · ' + pad(h) + 'h ' + pad(m) + 'm';
      $$('[data-lcs-left]').forEach(function (el) { if (el.textContent !== txt) el.textContent = txt; });
    }
    promo(); tick();
    setInterval(tick, 1000);
  }

  /* Enroll / Claim buttons: open the sitewide enroll form (snippets/lafs-enroll-form) with the course chosen and a note.
     Capture phase, so the fields are set before the form's own listener opens it. Never overwrites the visitor's words. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.lcs [data-lafs-enroll]') : null;
    if (!b) return;
    var sel = document.getElementById('lef-prog'), c = b.getAttribute('data-lef-course');
    if (sel && c) { for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === c || sel.options[i].text === c) { sel.selectedIndex = i; break; } }
    var msg = document.getElementById('lef-body');
    if (msg && (!msg.value || msg.value === msg.getAttribute('data-lcs-auto'))) {
      var t = b.getAttribute('data-pp-tier') || '', txt = (b.textContent || '').replace(/\s+/g, ' ');
      var amt = /\bclaim\b/i.test(txt) ? ((txt.match(/\$\s?[\d,]+/) || [''])[0]) : '';
      var v = (t ? 'Interested in the ' + t + '.' : '') + (amt ? ' I would like to claim the ' + amt + ' discount.' : '');
      if (v) { msg.value = v.trim(); msg.setAttribute('data-lcs-auto', msg.value); }
    }
  }, true);

  function initAll() { [].forEach.call(document.querySelectorAll('[data-lcs]'), init); }
  window.__lcsInit = initAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
